$ ->
  if $('#js-inquiries').length > 0

    # 問い合わせの著作権周り
    $(".js-inquiry-title").change ->
      if $(@).val() == "infringement"
        $(".js-inquiry-problem").slideDown()
      else
        $(".js-inquiry-problem").slideUp()

      if $(@).val() == "advertisement"
        $(".js-inquiry-ad").slideDown()
      else
        $(".js-inquiry-ad").slideUp()

      if $(@).val() == "about_press"
        $(".js-inquiry-press").slideDown()
      else
        $(".js-inquiry-press").slideUp()